// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IAssessmentGeneralProofGetListAttrs,
  IAssessmentGeneralProofDownloadDocumentAttrs,
} from 'interfaces/back-office/assessment/registration/general-proof/general-proof-view.interface'

const useAssessmentGeneralProof = () => {
  // Hook
  const {
    assessmentGeneralProof: {
      assessmentGeneralProof_loading,
      assessmentGeneralProof_list,
      assessmentGeneralProof_CLEAR_LIST,
      assessmentGeneralProof_fetchList: fetchList,
      assessmentGeneralProof_downloadDocument: downloadDocument,
    },
  } = useStores()

  /**
   * @description Fetch assessment general proof list
   *
   * @param {IAssessmentGeneralProofGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentGeneralProof_fetchList = useCallback(
    (payload: IAssessmentGeneralProofGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Download assessment general proof document
   *
   * @param {IAssessmentGeneralProofDownloadDocumentAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const assessmentGeneralProof_downloadDocument = useCallback(
    (payload: IAssessmentGeneralProofDownloadDocumentAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        downloadDocument({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [downloadDocument],
  )

  return {
    assessmentGeneralProof_loading,
    assessmentGeneralProof_list,
    assessmentGeneralProof_CLEAR_LIST,
    assessmentGeneralProof_fetchList,
    assessmentGeneralProof_downloadDocument,
  }
}

export { useAssessmentGeneralProof }
